import { render, staticRenderFns } from "./datapropuestaTecpro.vue?vue&type=template&id=12d19ff6&scoped=true&"
import script from "./datapropuestaTecpro.vue?vue&type=script&lang=js&"
export * from "./datapropuestaTecpro.vue?vue&type=script&lang=js&"
import style0 from "./datapropuestaTecpro.vue?vue&type=style&index=0&id=12d19ff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d19ff6",
  null
  
)

export default component.exports